import React from 'react'

import { Button } from '@sketch/components'
import Section from 'components/Section'

import { useModalContext } from 'containers/ModalManager'

import DeleteAccountModal from '../../modals/DeleteAccountModal'

type OtherOptionsPanelProps = {
  hasPersonalIdentity: boolean
}
export const OtherOptionsPanel = ({
  hasPersonalIdentity,
}: OtherOptionsPanelProps) => {
  const { showModal } = useModalContext()

  /* Avoid a scenario where only the "Other" title was being rendered */
  if (!hasPersonalIdentity) {
    return null
  }

  return (
    <Section title="Other">
      <Button
        variant="negative"
        size="40"
        onClick={() => showModal(DeleteAccountModal)}
      >
        Delete Account&hellip;
      </Button>
    </Section>
  )
}
